package com.clany.backoffice.model

import kotlinx.serialization.Serializable

@Serializable
data class AccountResponse(
    val id: String,
    val name: String,
    val users: List<AccountUserResponse>,
    val createdAt: String
)
